<template>
  <div class="banner-container d-flex align-center" style="height: 72px">
    <div class="banner-content">
      <v-btn text :to="{ name: path, params: params }" class="px-0" exact>
        <v-icon left>mdi-chevron-left</v-icon>
        {{ path }}
      </v-btn>
    </div>
  </div>
</template>
<script>
  export default {
    name: "GoToBanner",
    props: {
      path: String,
      params: Object,
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/GoToBanner.vue